import BUDetails from './Detail';

export default BUDetails;
